export interface AppReview {
  title: string;
  rating: number;
  author: string;
  date: string;
  body: string;
}

export interface AppInfo {
  slug: string;
  name: string;
  subtitle: string;
  category: string;
  status: "live" | "coming-soon";
  appStoreUrl?: string;
  /** Path under /public, e.g. /apps/guffaw/icon.png. Falls back to emoji if missing. */
  icon?: string;
  iconEmoji: string;
  /** Two colors used for the icon fallback + card accents */
  gradient: [string, string];
  tagline: string;
  description: string[];
  features: string[];
  /** Paths under /public. Missing images render as placeholder frames. */
  screenshots: string[];
  rating?: number;
  ratingCount?: string;
  ageRating: string;
  size?: string;
  requires?: string;
  price: string;
  reviews: AppReview[];
  privacyUrl?: string;
}

export const apps: AppInfo[] = [
  {
    slug: "guffaw",
    name: "Guffaw",
    subtitle: "Funny Photo Video Booth",
    category: "Photo & Video",
    status: "live",
    appStoreUrl:
      "https://apps.apple.com/us/app/guffaw-funny-photo-video-booth/id652205961",
    icon: "/apps/guffaw/icon.png",
    iconEmoji: "🤪",
    gradient: ["#FF8A3D", "#E8467C"],
    tagline: "Change your face. Change your voice. Lose it laughing.",
    description: [
      "Guffaw turns your camera into a comedy machine. Pick from a huge library of face and voice effects, stack multiple face filters on top of each other to invent your own looks, then record videos or snap photos and share them with friends.",
      "No login required — open the app and start making faces. Everything you create is saved right inside the app, ready to share on Instagram, X, iMessage, or email.",
    ],
    features: [
      "75 hilarious face & video effects (41 free)",
      "39 funny voice & background sound effects (9 free)",
      "Mix multiple face filters — a unique feature",
      "Record videos and take photos in one tap",
      "Share straight to Instagram, X, Messages & more",
      "No login required — private by design",
    ],
    screenshots: [
      "/apps/guffaw/screen-1.png",
      "/apps/guffaw/screen-2.png",
      "/apps/guffaw/screen-3.png",
      "/apps/guffaw/screen-4.png",
    ],
    rating: 4.4,
    ratingCount: "19K ratings",
    ageRating: "4+",
    size: "46.4 MB",
    requires: "iOS 13.0 or later",
    price: "Free · In-app purchases",
    reviews: [
      // TODO: replace with real reviews copied from your App Store Connect account
      {
        title: "My friends all downloaded it",
        rating: 5,
        author: "Sample review",
        date: "2025",
        body: "Started sending funny clips to my friends and now the whole group chat uses it. Mixing face filters together is the best part.",
      },
      {
        title: "Instant laughs",
        rating: 5,
        author: "Sample review",
        date: "2025",
        body: "The voice effects combined with the face filters had my kids crying with laughter. Super easy to record and share.",
      },
      {
        title: "Funniest app on my phone",
        rating: 4,
        author: "Sample review",
        date: "2025",
        body: "So many effects to play with. Would love even more free filters, but what's here is genuinely hilarious.",
      },
    ],
    privacyUrl: "http://www.appkruti.com/privacypolicy.html",
  },
  {
    slug: "laugh-with-me",
    name: "Laugh With Me",
    subtitle: "Laughing Yoga",
    category: "Health & Fitness",
    status: "coming-soon",
    icon: "/apps/laugh-with-me/icon.png",
    iconEmoji: "😄",
    gradient: ["#7C4DFF", "#B33FA0"],
    tagline: "Guided laughing yoga sessions for a lighter, happier you.",
    description: [
      "Laugh With Me brings the practice of laughing yoga to your pocket. Follow along with guided sessions that combine intentional laughter, breathing exercises, and gentle movement — a practice shown to reduce stress and boost your mood.",
      "Currently in development. Check back soon, or follow Zinnobyte for launch updates.",
    ],
    features: [
      "Guided laughing yoga sessions",
      "Breathing and relaxation exercises",
      "Daily laughter reminders",
      "Track your laughter streak",
    ],
    screenshots: [
      "/apps/laugh-with-me/screen-1.png",
      "/apps/laugh-with-me/screen-2.png",
      "/apps/laugh-with-me/screen-3.png",
    ],
    ageRating: "4+",
    price: "Coming soon",
    reviews: [],
  },
];

export const getApp = (slug: string | undefined): AppInfo | undefined =>
  apps.find((a) => a.slug === slug);
